// VideoHelmet.tsx
import React from 'react';
import {Helmet} from '@common/seo/helmet';

interface VideoShareMetadataProps {
    clipId: number | string;
    title: string;
    description: string;
    videoUrl: string;
    thumbnail: string; // Added thumbnail property
}

const VideoHelmet: React.FC<VideoShareMetadataProps> = ({
  clipId,
  title,
  description,
  videoUrl,
  thumbnail,
}) => {
  const shareUrl = `https://vibe.sintonizy.com/zy/${clipId}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title} - Sintonizy Vibe Clips</title>
      <meta name="description" content={description} />

      {/* Open Graph Meta Tags */}
      <meta property="og:site_name" content="Sintonizy Vibe" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={shareUrl} />
      <meta property="og:type" content="video.other" />
      <meta property="og:video" content={videoUrl} />
      <meta property="og:video:url" content={videoUrl} />
      <meta property="og:video:secure_url" content={videoUrl} />
      <meta property="og:video:type" content="video/mp4" />
      <meta property="og:video:width" content="854" />
      <meta property="og:video:height" content="480" />
      <meta property="og:image" content={thumbnail} />
      <meta property="og:image:secure_url" content={thumbnail} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="854" />
      <meta property="og:image:height" content="480" />

      {/* WhatsApp specific */}
      <meta property="og:image:alt" content={title} /> 
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={shareUrl} />
      <meta name="twitter:image" content={thumbnail} />
    </Helmet>
  );
};

export default VideoHelmet;